//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { IsField, BindsAttrs } from '@/mixins'

export default {
  mixins: [
    IsField,
    BindsAttrs
  ],
  props: {
    appendsButton: {
      type: Boolean,
      default: false,
    },
    seamless: {
      type: Boolean,
      default: false,
    },
    persistentHint: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    classes () {
      return {
        ...this.fieldClasses,
        'k-field-text--appends-button': this.appendsButton,
        'k-field-text--seamless': this.seamless,
      }
    }
  }
}
